import { fmtDateLabel } from './format';

function mapRow(r) {
  return {
    strike: r.strike,
    vol: r.vol,
    volChg: r.volChg,
    oiChg: r.oiChg,
    netOi: r.oi,
    prcChg: r.prcChg,
    ltp: r.ltp,
    volStr: r.vs,
    oiStr: r.os,
    atm: r.atm,
    interpret: r.interp,
    interpretClass: r.intCls === 'g' ? 'ib-g' : r.intCls === 'r' ? 'ib-r' : 'ib-a',
    hv: r.hvs,
    ho: r.hos,
  };
}

export function toTableRows(data) {
  return {
    ceRows: (data?.top6CE || []).map(mapRow),
    peRows: (data?.top6PE || []).map(mapRow),
  };
}

export function toSpotTableRows(data) {
  const mpMap = {};
  (data?.mpTrend || []).forEach(m => { mpMap[m.date] = m; });
  return (data?.spotLevels || []).map(s => {
    const mp = mpMap[s.date] || {};
    return {
      date: fmtDateLabel(s.date),
      resistance: s.resistance,
      spot: s.spot,
      support: s.support,
      maxPain: mp.maxpain,
      pcr: mp.pcr,
    };
  });
}

export function toChartSeries(data) {
  const label = d => fmtDateLabel(d);
  const ohlc = data?.ohlcData || [];
  const spotLevels = data?.spotLevels || [];
  const lvlMap = {};
  spotLevels.forEach(s => { lvlMap[s.date] = s; });

  return {
    oci: (data?.ociTrend || []).map(x => ({ time: label(x.date), oci: x.oci })),
    cepeOI: (data?.cepeOITrend || []).map(x => ({ time: label(x.date), ceOI: x.ceOI, peOI: x.peOI })),
    mp: (data?.mpTrend || []).map(x => ({ time: label(x.date), spot: x.spot, maxpain: x.maxpain, pcr: x.pcr })),
    dec: (data?.decTrend || []).map(x => ({ time: label(x.date), ce_decay: x.ce_decay, pe_decay: x.pe_decay })),
    ohlc: {
      labels: ohlc.map(x => label(x.date)),
      o: ohlc.map(x => x.open),
      h: ohlc.map(x => x.high),
      l: ohlc.map(x => x.low),
      c: ohlc.map(x => x.close),
      resistance: ohlc.map(x => lvlMap[x.date]?.resistance ?? null),
      support: ohlc.map(x => lvlMap[x.date]?.support ?? null),
    },
  };
}